import { useContext } from "react";
import axios, { HttpStatusCode } from "axios";
import AuthContext from "common/store/AuthContext";
import { REPORT_TYPE } from "common/types/consts/Defines";
import { ReportMaintenanceData, LockReportRequest } from "../types/ReportData";
import { generateErrorMsg, getServerUrl } from "utils/commonTools";
import { PostResponse } from "common/types/responses/BasicResponse";

export const useReport = () => {
  const authCtxt = useContext(AuthContext);
  const { token } = authCtxt;

  /**
   * 指定した月のレポート情報を取得する
   * @param parkId
   * @param yearMonth
   * @param reportType
   * @returns
   */
  const getReports = async (
    parkId: number,
    yearMonth: Date,
    reportType: REPORT_TYPE
  ): Promise<{ succeeded: boolean; msg: string; data?: ReportMaintenanceData[] }> => {
    const config = {
      headers: { "Content-type": "application/json", Authorization: `Bearer ${token}` },
    };

    try {
      const { data } = await axios.get<ReportMaintenanceData[]>(
        getServerUrl() +
          `admin/report/${parkId}/${reportType}/${yearMonth.getFullYear()}/${
            yearMonth.getMonth() + 1
          }`,
        config
      );

      return {
        succeeded: true,
        msg: "",
        data,
      };
    } catch (error) {
      var errMsg = generateErrorMsg(error);
      return { succeeded: false, msg: errMsg };
    }
  };

  //--------------------------------------
  // ロック処理の実行
  //--------------------------------------
  const setLock = async (
    parkId: number,
    data: ReportMaintenanceData[],
    reportType: REPORT_TYPE
  ): Promise<{ succeeded: boolean; msg: string }> => {
    const config = {
      headers: { "Content-type": "application/json", Authorization: `Bearer ${token}` },
    };
    try {
      const url = getServerUrl() + `admin/report/lock/${parkId}`;
      const response = await axios.post(
        url,
        data.map(
          (x) =>
            ({
              reportDate: x.reportDate,
              isLocked: x.isLocked,
              reportType,
            } as LockReportRequest)
        ),
        config
      );
      if (response.status === HttpStatusCode.BadRequest) {
        return { succeeded: false, msg: response.data.toString() };
      }

      const responseData = response.data as PostResponse;
      if (!responseData) {
        return { succeeded: false, msg: "取得したデータに異常がありました" };
      }

      authCtxt.updateToken(responseData.token, new Date(responseData.expiresAt));

      return { succeeded: true, msg: "" };
    } catch (error: unknown) {
      var errMsg = generateErrorMsg(error);
      return { succeeded: false, msg: errMsg };
    }
  };

  return { getReports, setLock };
};
